// extracted by mini-css-extract-plugin
var _1 = "_p9JpN";
var _2 = "_wltYs";
var _3 = "_p_ahg";
var _4 = "_SVQYe";
export { _1 as "noRows", _2 as "noRowsText", _3 as "rowStyle", _4 as "tableContainer" }
